var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReturnGoodsEditingSection',{attrs:{"RG":_vm.RG,"createData":_vm.createData,"optionsStorage":_vm.optionsStorage},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }